import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnchoredSectionComponent } from './components/anchored-section.component';

@NgModule({
  declarations: [AnchoredSectionComponent],
  imports: [CommonModule],
  exports: [AnchoredSectionComponent],
})
export class AnchoredSectionModule {}
